
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSideProps, NextPage } from 'next'

import { ListingNotFound } from '@/containers/ListingNotFound'
import { getHousesForSalesPathSegment, getListingDetailPathSegment } from '@/i18n-routes'
import { Listing } from '@/types/nika'

import { getListing } from '../../api/api-nika'

const ListingUuidPage: NextPage = () => {
  return <ListingNotFound />
}

 const _getServerSideProps: GetServerSideProps = async ({ params, req }) => {
  const uuid = Array.isArray(params.uuid) ? params.uuid[0] : params.uuid

  let listing = null
  try {
    listing = (await getListing(uuid)) as Listing
  } catch (e) {
    return {
      props: {},
    }
  }

  const listingCountry = listing.geo_country
  const pathSegment = getSegment(listingCountry)

  const originQuery = req.url.split('?')[1]
  const destinationPath = originQuery ? `/${pathSegment}/${uuid}/?${originQuery}` : `/${pathSegment}/${uuid}/`

  return {
    redirect: {
      destination: destinationPath,
      permanent: false,
    },
  }
}

function getSegment(country: string) {
  return `${getHousesForSalesPathSegment(country as Locale)}/${getListingDetailPathSegment(country as Locale)}`
}

export default ListingUuidPage


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/listings/[uuid]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  